export const eyeOff = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 25.98 22.264">
                <path id="Icon_ionic-md-eye-off" data-name="Icon ionic-md-eye-off" d="M15.243,9.185a5.889,5.889,0,0,1,5.908,5.862,5.639,5.639,0,0,1-.423,2.145l3.45,3.421a13.861,13.861,0,0,0,4.053-5.566,13.991,13.991,0,0,0-17.7-7.972l2.551,2.534A5.842,5.842,0,0,1,15.243,9.185ZM3.433,5.99l2.7,2.673.545.539A13.794,13.794,0,0,0,2.25,15.046a14.012,14.012,0,0,0,18.165,7.8l.5.493,3.461,3.421,1.5-1.49L4.929,4.5Zm6.528,6.476,1.832,1.815a3.321,3.321,0,0,0-.093.76,3.525,3.525,0,0,0,3.543,3.514,3.332,3.332,0,0,0,.765-.093l1.832,1.815a5.877,5.877,0,0,1-8.506-5.241A5.791,5.791,0,0,1,9.961,12.466Zm5.091-.91,3.722,3.693.023-.186a3.525,3.525,0,0,0-3.543-3.514Z" transform="translate(-2.25 -4.5)" fill="#fff" opacity="0.8" />
            </svg>
        </>
    )
}
export const eyeOn = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 25.98 17.513">
                <path id="Icon_ionic-md-eye" data-name="Icon ionic-md-eye" d="M15.24,7.383A13.969,13.969,0,0,0,2.25,16.139a14.013,14.013,0,0,0,25.98,0A13.969,13.969,0,0,0,15.24,7.383Zm0,14.6a5.84,5.84,0,1,1,5.9-5.84A5.888,5.888,0,0,1,15.24,21.979Zm0-9.342a3.5,3.5,0,1,0,3.543,3.5A3.534,3.534,0,0,0,15.24,12.637Z" transform="translate(-2.25 -7.383)" fill="#cdd3d9" />
            </svg>
        </>
    )
}
export const submitIcon = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="22.783" height="19.528" viewBox="0 0 22.783 19.528">
                <path id="Icon_material-send" data-name="Icon material-send" d="M3.011,24.028l22.772-9.764L3.011,4.5,3,12.094l16.273,2.17L3,16.434Z" transform="translate(-3 -4.5)" fill="#fff" />
            </svg>
        </>
    )
}
export const closeIcon = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="39.814" height="39.814" viewBox="0 0 39.814 39.814">
                <path id="close-filled" d="M22.157,2.25A19.784,19.784,0,0,0,2.25,22.157,19.784,19.784,0,0,0,22.157,42.064,19.784,19.784,0,0,0,42.064,22.157,19.784,19.784,0,0,0,22.157,2.25Zm7.678,29.86-7.678-7.678L14.479,32.11,12.2,29.835l7.678-7.678L12.2,14.479,14.479,12.2l7.678,7.678L29.835,12.2l2.275,2.275-7.678,7.678,7.678,7.678Z" transform="translate(-2.25 -2.25)" fill="#fff" />
            </svg>

        </>
    )
}
export const closeIconFlat = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 24 24">
                <path d="M 4.2382812 2.9882812 A 1.250125 1.250125 0 0 0 3.3671875 5.1347656 L 10.232422 12 L 3.3613281 18.869141 A 1.2512475 1.2512475 0 1 0 5.1308594 20.638672 L 12 13.767578 L 18.865234 20.632812 A 1.250125 1.250125 0 1 0 20.632812 18.865234 L 13.767578 12 L 20.625 5.1425781 A 1.250125 1.250125 0 1 0 18.857422 3.375 L 12 10.232422 L 5.1347656 3.3671875 A 1.250125 1.250125 0 0 0 4.2382812 2.9882812 z" fill="#fff"></path>
            </svg>
        </>
    )
}
export const micIcon = () => {
    return (
        <>
            <svg id="mic" xmlns="http://www.w3.org/2000/svg" width="36" height="28" viewBox="0 0 62 62">
                <path id="Path_17" data-name="Path 17" d="M26.438,42.625a9.691,9.691,0,0,0,9.688-9.687V9.688a9.688,9.688,0,0,0-19.375,0v23.25A9.691,9.691,0,0,0,26.438,42.625ZM40,27.125v5.813a13.562,13.562,0,1,1-27.125,0V27.125H9v5.813A17.446,17.446,0,0,0,24.5,50.272v7.853H16.75V62H36.125V58.125h-7.75V50.272a17.446,17.446,0,0,0,15.5-17.334V27.125Z" transform="translate(2.625)" fill="#f1582c" />
                <path id="Path_18" data-name="Path 18" d="M0,0H62V62H0Z" fill="none" />
            </svg>
        </>
    )
}
export const pauseIcon = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 30 30">
                <path id="stop" d="M11.786,7.5H33.214A4.286,4.286,0,0,1,37.5,11.786V33.214A4.286,4.286,0,0,1,33.214,37.5H11.786A4.286,4.286,0,0,1,7.5,33.214V11.786A4.286,4.286,0,0,1,11.786,7.5Z" transform="translate(-7.5 -7.5)" fill="#fff" />
            </svg>
        </>
    )
}
export const restartIcon = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="39.95" height="40" viewBox="0 0 39.95 40">
                <path id="Icon_open-reload" data-name="Icon open-reload" d="M20,0A20,20,0,1,0,34.2,34.2l-3.6-3.6A15.011,15.011,0,1,1,19.95,5,14.546,14.546,0,0,1,30.4,9.55L24.95,15h15V0L34,5.95A19.888,19.888,0,0,0,19.95,0Z" fill="#fff" />
            </svg>
        </>
    )
}
export const infoIcon = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46">
                <g id="Group_65" data-name="Group 65" transform="translate(-440 -883)">
                    <circle id="Ellipse_6" data-name="Ellipse 6" cx="23" cy="23" r="23" transform="translate(440 883)" fill="#fff" opacity="0.22" />
                    <text id="_" data-name="!" transform="translate(462 916)" fill="#fff"
                        style={{
                            fontSize: '30px',
                            fontWeight: "500",
                            fontFamily: "Poppins-Medium, Poppins"
                        }}
                    ><tspan x="-4.815" y="0">!</tspan></text>
                </g>
            </svg>

        </>
    )
}
export const sendIcon = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="32.004" height="24" viewBox="0 0 32.004 32.004">
                <g id="send" transform="translate(0.004)">
                    <path id="Path_14" data-name="Path 14" d="M37.661,2.27a.944.944,0,0,1-.213.307L17.28,22.744l5.7,9.494a1.062,1.062,0,0,0,1.893-.127Z" transform="translate(-5.761 -0.757)" fill="#001e3e" />
                    <path id="Path_15" data-name="Path 15" d="M10.013,20.527l-9.494-5.7a1.062,1.062,0,0,1,.127-1.893L30.493.14a1.113,1.113,0,0,0-.313.22Z" transform="translate(0 -0.047)" fill="#001e3e" />
                    <path id="Path_16" data-name="Path 16" d="M0,0H32V32H0Z" transform="translate(-0.001)" fill="none" />
                </g>
            </svg>
        </>
    )
}
export const checkIcon = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 87.787 87.787">
                <path fill="#f1582c" id="Icon_ionic-ios-checkmark-circle" data-name="Icon ionic-ios-checkmark-circle" d="M47.268,3.375A43.893,43.893,0,1,0,91.162,47.268,43.887,43.887,0,0,0,47.268,3.375ZM69.743,35.134,41.528,63.475h-.021a3.811,3.811,0,0,1-2.448,1.161,3.694,3.694,0,0,1-2.469-1.2L24.773,51.615a.841.841,0,0,1,0-1.2l3.756-3.756a.816.816,0,0,1,1.182,0l9.37,9.37L64.826,30.091a.833.833,0,0,1,.591-.253h0a.766.766,0,0,1,.591.253L69.7,33.91A.832.832,0,0,1,69.743,35.134Z" transform="translate(-3.375 -3.375)" />
            </svg>

        </>
    )
}
export const backIcon = () => {
    return (
        <>
            <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-tj5bde-Svg" style={{ transform: "rotate(90deg)" }}><path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
        </>
    )
}
export const trashIcon = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 15.75 18">
                <path id="Icon_awesome-trash" data-name="Icon awesome-trash" d="M15.187,1.125H10.969l-.33-.657A.844.844,0,0,0,9.882,0H5.864a.834.834,0,0,0-.752.468l-.33.657H.562A.562.562,0,0,0,0,1.687V2.812a.563.563,0,0,0,.562.563H15.187a.562.562,0,0,0,.563-.562V1.687A.562.562,0,0,0,15.187,1.125ZM1.87,16.418A1.688,1.688,0,0,0,3.554,18H12.2a1.687,1.687,0,0,0,1.684-1.582L14.625,4.5H1.125Z" transform="translate(0 0)" fill="#fff" />
            </svg>
        </>
    )
}
export const editIcon = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 27.004 27.004">
                <path id="Icon_material-edit" data-name="Icon material-edit" d="M4.5,25.875V31.5h5.625l16.59-16.59L21.09,9.285ZM31.065,10.56a1.494,1.494,0,0,0,0-2.115l-3.51-3.51a1.494,1.494,0,0,0-2.115,0L22.695,7.68l5.625,5.625,2.745-2.745Z" transform="translate(-4.5 -4.496)" fill="#fff" />
            </svg>
        </>
    )
}

export const userIcon = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 34.875 34.875">
                <path id="Icon_awesome-ban" data-name="Icon awesome-ban" d="M18,.563A17.438,17.438,0,1,0,35.438,18,17.438,17.438,0,0,0,18,.563Zm9.148,8.289A12.939,12.939,0,0,1,28.6,25.42L10.58,7.4A12.939,12.939,0,0,1,27.148,8.852Zm-18.3,18.3A12.939,12.939,0,0,1,7.4,10.58L25.42,28.6A12.939,12.939,0,0,1,8.852,27.148Z" transform="translate(-0.563 -0.563)" fill="#fff" />
            </svg>
        </>
    )
}
export const activeIcon = () => {
    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 36 26.846">
                <path id="Icon_awesome-check" data-name="Icon awesome-check" d="M12.227,30.9.527,19.2a1.8,1.8,0,0,1,0-2.546L3.073,14.1a1.8,1.8,0,0,1,2.546,0L13.5,21.986,30.382,5.1a1.8,1.8,0,0,1,2.546,0L35.473,7.65a1.8,1.8,0,0,1,0,2.546l-20.7,20.7A1.8,1.8,0,0,1,12.227,30.9Z" transform="translate(0 -4.577)" fill="#fff" />
            </svg>

        </>
    )
}
